import React, { createContext, useContext, useState } from 'react';

const Web3Context = createContext(null);
export const useWeb3 = () => useContext(Web3Context);

// Mock wallet data for demo
const MOCK_WALLET = {
  account: '0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb',
  balance: '12.5',
  chainId: 1,
};

const SUPPORTED_CHAINS = {
  1: { name: 'Ethereum Mainnet' },
  5: { name: 'Goerli Testnet' },
  11155111: { name: 'Sepolia Testnet' },
  137: { name: 'Polygon Mainnet' },
};

export const Web3Provider = ({ children }) => {
  const [account, setAccount] = useState(null);
  const [chainId, setChainId] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [balance, setBalance] = useState('0');
  const [error, setError] = useState(null);

  const connect = () => {
    setAccount(MOCK_WALLET.account);
    setBalance(MOCK_WALLET.balance);
    setChainId(MOCK_WALLET.chainId);
    setIsConnected(true);
    setError(null);
  };

  const disconnect = () => {
    setAccount(null);
    setChainId(null);
    setIsConnected(false);
    setBalance('0');
  };

  const switchNetwork = (targetChainId) => {
    setChainId(targetChainId);
    return true;
  };

  const getNetworkName = () => {
    if (!chainId) return 'Not connected';
    return SUPPORTED_CHAINS[chainId]?.name || `Chain ${chainId}`;
  };

  return (
    <Web3Context.Provider value={{ 
      account, 
      chainId, 
      isConnected, 
      balance, 
      error, 
      connect, 
      disconnect,
      switchNetwork,
      getNetworkName,
      supportedChains: SUPPORTED_CHAINS,
      mockMode: true
    }}>
      {children}
    </Web3Context.Provider>
  );
};
